import template from './sw-cms-block-jga-revocation-button.html.twig';

export default {
    template,
};
